import './Searchnav.css';
import WelcomeName from "./WelcomeName";
function Searchnav() {
    return (
        <>
            <div class="searchnav-container">
                <div class="searchnav-wrap">
                    <div class="searchnav-row">
                        <div class="searchnav-box">
                            <img src={process.env.PUBLIC_URL + "/images/Acc_Logo_Black_Purple_RGB.png"} class="acc-logo" alt="logo" />
                            <p class="desktop-tag"><span>Learning & Talent Transformation</span> <br /> <p className="desktop-tag-1">Training Nomination Request</p></p>
                            <p class="mobile-tag"><span>L&TT</span> <br /> <p className="mobile-tag-1">TNR</p></p>
                        </div>
                    </div>
                    <div class="searchnav-row">
                        <div class="searchnav-box" style={{ textAlign: 'right', marginTop: '10px' }}>
                            <WelcomeName />
                            <img src={process.env.PUBLIC_URL + "/images/Avatar.png"} class="user-img" alt="user-image" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Searchnav
